import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { COLORS } from '../../utils/styles'
import { sendGaEvent } from 'wsc/utils/googleTagManager'

const ScStickyButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 52px;
  height: 52px;
  box-shadow: 0 3px 6px 0 rgba(26, 88, 78, 0.3);
  border-radius: 50%;
  background-color: ${COLORS.GREYISH_TEAL};
  user-select: none;

  margin-top: 12px;
  font-size: 0.75rem;
  font-weight: bold;
  color: ${COLORS.WHITE};
  svg {
    height: 16px;
    width: 16px;
  }
  &:active {
    background-color: ${COLORS.DARK_GREEN};
  }
`

const StickyButton = ({ text, icon, onClickFunc }) => {
  return (
    <ScStickyButton
      onClick={() => {
        if (text === 'NAME') {
          sendGaEvent({
            category: 'Baby Name Search',
            action: 'Clicked Float Button',
            label: window.location.pathname + window.location.search,
          })
        }

        if (text === 'SHARE') {
          sendGaEvent({
            category: 'Baby Name Share',
            action: 'Mobile Float click',
            label: window.location.pathname + window.location.search,
          })
        }

        onClickFunc()
      }}
    >
      {icon}
      {text}
    </ScStickyButton>
  )
}

StickyButton.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClickFunc: PropTypes.func.isRequired,
}

export default StickyButton
